export * from './Page';
import { default as Content } from './PageContent';
import { default as Layout } from './PageLayout';
import { default as Sidebar } from './PageSidebar';
import { default as Title } from './PageTitle';
import { default as Intro } from './PageIntro';

export const PageLayout = Object.assign(Layout, {
	Sidebar,
	Content,
	Title,
	Intro,
});
